import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 9h.01","key":"svg-0"}],["path",{"d":"M11 12h1v4h1","key":"svg-1"}],["path",{"d":"M12 3c7.2 0 9 1.8 9 9c0 7.2 -1.8 9 -9 9c-7.2 0 -9 -1.8 -9 -9c0 -7.2 1.8 -9 9 -9","key":"svg-2"}]]

const IconInfoSquareRounded = createReactComponent('outline', 'info-square-rounded', 'InfoSquareRounded', __iconNode);

export default IconInfoSquareRounded;